import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Foodprogrampopup , Btnprogram } from '../../css/adminstylesheet';
import PersonIcon from '@mui/icons-material/Person';
import { Container, Input } from '@mui/material';
import Colorapps from '../../../configcss/color';

export default function FoodpopupAdmin() {
  const [open, setOpen] = React.useState(false);
  const handleOpenModal = () =>  setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      {/* UI of the box */}
      <Container onClick={() => handleOpenModal()}>
                  <Typography  variant='h5' style={{ marginTop: '12px', color: '#A098AE', fontFamily: 'sans-serif', fontSize: '18px', fontWeight: '400' }} >
                    <b>Food Program</b>
                  
                  </Typography>
                  <Typography variant='h5' style={{ marginTop: '7px', color: 'black', fontSize: '30px', fontWeight: 'bold' }}>
                    988
                  </Typography>
                  <Typography style={{ fontSize: '10px', textAlign: 'center' }}>
                    +10% than last month
                  </Typography>
                  <div className="sidebar-container">
                    <PersonIcon />
                  </div>
                </Container>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        {/* MODEL EDIT UI  */}
        <Box sx={Foodprogrampopup}>
          <Typography sx={{textAlign:'center' , fontFamily:'bold'}} id="modal-modal-title" variant="h6" component="h2">
            <b>Add the Total Food Program</b>
          </Typography>
          <br></br>
          <Input
          sx={{marginLeft:'90px'}}
          placeholder='Add the Total value'
          >
          </Input>
          <Button variant="contained" sx={{borderRadius:"40px",background:Colorapps.backgroundtheme,color:'white',px:"10px"}}>ADD</Button>
                           
        </Box>
      </Modal>
    </div>
  );
}